//====================================================
//  Function: Show/hidden
//====================================================
function fn_parts_show_hidden(){
	if ($( '.js-active-class-toggle' ).length){
		$( '.js-active-class-toggle' ).bind( 'click' , function() {
			$(this).closest( '.js-hidden-block' ).find( '.js-hidden-content' ).toggleClass( class_active ).find( 'input' ).focus();
			if ($( '.language-dropdown.is-active' ).length){
				$( '.language-dropdown.is-active' ).removeClass( 'is-active' );
			}
			if ($( '.navigation.is-collapse' ).length){
				$( '.navigation.is-collapse' ).removeClass( 'is-collapse' );
			}
		});
	}

	if ($( '.js-active-class-trigger' ).length){
		$( '.js-active-class-trigger' ).bind( 'click' , function() {
			$(this).closest( '.js-hidden-block' ).toggleClass( class_active ).find( '.js-hidden-content' ).toggleClass( class_active );
		});
	}

	// if ($( '.js-remove-class-trigger' ).length){
	// 	$( '.js-remove-class-trigger' ).bind( 'click' , function() {
	// 		$(this).closest( '.js-remove-block' ).find( '.js-hidden-content' ).removeClass( class_active );
	// 	});
	// }

	// if ($( '.js-hidden-trigger' ).length){
	// 	$( '.js-hidden-trigger' ).bind( 'click' , function() {
	// 		$(this).hide();
	// 		$(this).closest( '.js-hidden-block' ).find( '.js-hidden-content' ).addClass( class_active );
	// 	});
	// }

	$(document).on('click', function(event) {
		if (!$(event.target).closest( '.search-group' ).length) {
			$('.search-group .js-hidden-content.' + class_active + '').removeClass( class_active );
		}
	});
}

